export enum AdministratorTabType {
  Organization = 'foretag',
  PrivateIndividual = 'privatperson',
}
